import { render } from "./IndividualStats.vue?vue&type=template&id=0784bdd3"
import script from "./IndividualStats.vue?vue&type=script&lang=js"
export * from "./IndividualStats.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__